import { render, staticRenderFns } from "./varietyDatabase.vue?vue&type=template&id=38047148&"
import script from "./varietyDatabase.vue?vue&type=script&lang=js&"
export * from "./varietyDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports